import arrowLeftSVG from '../assets/img/arrowLeft.svg';

window.VAE = window.VAE || {};

const loadedScripts = {}; 
VAE.loadExternalScript = function (url) {
  if (loadedScripts[url]) {
    return loadedScripts[url];
  }
  console.log(`VAE: Lade externes Skript "${url}"...`);
  loadedScripts[url] = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => {
      console.log(`VAE: Externes Skript "${url}" erfolgreich geladen`);
      resolve();
    };
    script.onerror = (err) => {
      console.error(`VAE: Fehler beim Laden des externen Skripts "${url}"`, err);
      delete loadedScripts[url]; 
      reject(new Error(`Script ${url} could not be loaded`));
    };
    document.head.appendChild(script);
  });
  return loadedScripts[url];
};

VAE.SharedUI = (function () {
  'use strict';

  function createCardComponent({ title, contentElements, cardClass }) {
    const card = document.createElement('div');
    card.className = 'vae-card';
    if (cardClass) {
        card.classList.add(cardClass);
    }

    if (title) {
      const header = document.createElement('h4');
      header.className = 'vae-card-header';
      header.textContent = title;
      card.appendChild(header);
    }

    const contentContainer = document.createElement('div');
    contentContainer.className = 'vae-card-content';

    if (Array.isArray(contentElements)) {
        contentElements.forEach(el => {
            if (el instanceof HTMLElement) {
                contentContainer.appendChild(el);
            }
        });
    } else if (contentElements instanceof HTMLElement) {
        contentContainer.appendChild(contentElements);
    } else {
        console.warn('VAE.SharedUI.createCardComponent: contentElements must be an HTMLElement or an array of HTMLElements.');
    }

    card.appendChild(contentContainer);

    return card;
  }

  function createNumericStepper({
    label,
    icon,
    initialValue = 0,
    minValue = 0,
    maxValue = 10,
    step = 1,
    unit = '',
    onChange = () => {},
    controlName
  }) {
    const container = document.createElement('div');
    container.className = 'vae-numeric-stepper';
    
    if (controlName) {
      container.setAttribute('data-vae-control', controlName);
    }

    if (label) {
      const labelContainer = document.createElement('div');
      labelContainer.className = 'vae-label-container';

      if (icon) {
        const iconElement = document.createElement('span');
        iconElement.className = 'vae-control-icon';
        iconElement.innerHTML = icon;
        labelContainer.appendChild(iconElement);
      }

      const labelElement = document.createElement('span');
      labelElement.className = 'vae-stepper-label';
      labelElement.textContent = label;
      labelContainer.appendChild(labelElement);
      container.appendChild(labelContainer);
    }

    const controlWrapper = document.createElement('div');
    controlWrapper.className = 'vae-stepper-controls';

    const minusButton = document.createElement('button');
    minusButton.textContent = '-';
    minusButton.className = 'vae-stepper-button vae-stepper-minus';
    minusButton.setAttribute('aria-label', `Decrease ${label || 'value'}`);

    const valueDisplay = document.createElement('span');
    valueDisplay.className = 'vae-stepper-value';
    
    const formattedInitialValue = unit === '%' ? Math.round(initialValue) : initialValue;
    valueDisplay.textContent = `${formattedInitialValue}${unit}`;

    const plusButton = document.createElement('button');
    plusButton.textContent = '+';
    plusButton.className = 'vae-stepper-button vae-stepper-plus';
    plusButton.setAttribute('aria-label', `Increase ${label || 'value'}`);

    let currentValue = initialValue;

    function updateButtons() {
      minusButton.disabled = currentValue <= minValue;
      plusButton.disabled = currentValue >= maxValue;
    }
    
    function formatValue(value) {
      if (unit === '%') {
        return Math.round(value);
      }
      return value;
    }
    
    function updateDisplay() {
      const formattedValue = formatValue(currentValue);
      valueDisplay.textContent = `${formattedValue}${unit}`;
    }

    function setValue(newValue) {
        newValue = Math.max(minValue, Math.min(maxValue, newValue));
        if (newValue !== currentValue) {
            currentValue = newValue;
            updateDisplay();
            updateButtons();
        } else if (newValue === currentValue) {
            updateDisplay();
            updateButtons();
        }
    }

    minusButton.addEventListener('click', () => {
      const newValue = Math.max(minValue, currentValue - step);
      if (newValue !== currentValue) {
        currentValue = newValue;
        updateDisplay();
        updateButtons();
        onChange(currentValue);
      }
    });

    plusButton.addEventListener('click', () => {
      const newValue = Math.min(maxValue, currentValue + step);
      if (newValue !== currentValue) {
        currentValue = newValue;
        updateDisplay();
        updateButtons();
        onChange(currentValue);
      }
    });

    controlWrapper.appendChild(minusButton);
    controlWrapper.appendChild(valueDisplay);
    controlWrapper.appendChild(plusButton);
    container.appendChild(controlWrapper);

    updateButtons(); 

    return { container, setValue };
  }

  function createDropdown({ 
      label, 
      icon,
      id, 
      options = [], // Array of { value: string, text: string }
      initialValue,
      onChange = () => {} 
  }) {
    const container = document.createElement('div');
    container.className = 'vae-dropdown-container';

    if (label) {
        const labelContainer = document.createElement('div');
        labelContainer.className = 'vae-label-container';

        if (icon) {
          const iconElement = document.createElement('span');
          iconElement.className = 'vae-control-icon';
          iconElement.innerHTML = icon;
          labelContainer.appendChild(iconElement);
        }

        const labelElement = document.createElement('label');
        labelElement.className = 'vae-dropdown-label';
        labelElement.textContent = label;
        labelElement.htmlFor = id;
        labelContainer.appendChild(labelElement);
        container.appendChild(labelContainer);
    }

    const selectWrapper = document.createElement('div');
    selectWrapper.className = 'vae-select-wrapper';

    const selectElement = document.createElement('select');
    selectElement.id = id;
    selectElement.className = 'vae-select';

    options.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option.value;
        optionElement.textContent = option.text;
        if (option.value === initialValue) {
            optionElement.selected = true;
        }
        selectElement.appendChild(optionElement);
    });

    selectElement.addEventListener('change', (event) => {
        onChange(event.target.value);
    });
    
    selectWrapper.appendChild(selectElement);
    container.appendChild(selectWrapper);

    function setValue(newValue) {
        selectElement.value = newValue;
        if (selectElement.value !== newValue) {
            console.warn(`VAE.SharedUI.createDropdown.setValue: Value "${newValue}" not found in options for dropdown #${id}.`);
        }
    }

    return { container, setValue };
  }

  function createSwitchToggle({
      label,
      icon,
      id,
      initialChecked = false,
      onChange = () => {}
  }) {
    const container = document.createElement('div');
    container.className = 'vae-switch-container';

    if (label) {
        const labelContainer = document.createElement('div');
        labelContainer.className = 'vae-label-container';

        if (icon) {
          const iconElement = document.createElement('span');
          iconElement.className = 'vae-control-icon';
          iconElement.innerHTML = icon;
          labelContainer.appendChild(iconElement);
        }

        const labelElement = document.createElement('label');
        labelElement.className = 'vae-switch-label';
        labelElement.textContent = label;
        labelElement.htmlFor = id;
        labelContainer.appendChild(labelElement);
        container.appendChild(labelContainer);
    }

    const switchWrapper = document.createElement('button');
    switchWrapper.id = id;
    switchWrapper.className = 'vae-switch';
    switchWrapper.setAttribute('role', 'switch');
    
    // Ensure initialChecked is always a boolean to fix WCAG 4.1.2 setAttribute issue
    const safeInitialChecked = Boolean(initialChecked);
    switchWrapper.setAttribute('aria-checked', String(safeInitialChecked));
    switchWrapper.setAttribute('aria-label', label || 'Toggle switch');

    const switchKnob = document.createElement('span');
    switchKnob.className = 'vae-switch-knob';
    switchWrapper.appendChild(switchKnob);

    let isChecked = safeInitialChecked;

    // Apply contrast-aware styling
    function applyContrastStyling() {
      if (typeof VAE !== 'undefined' && VAE.StateManager) {
        const colorState = VAE.StateManager.getState('colors');
        if (colorState?.highContrast) {
          // High contrast dark mode
          switchWrapper.style.setProperty('background-color', isChecked ? '#ffffff' : '#000000', 'important');
          switchWrapper.style.setProperty('border', '2px solid #ffffff', 'important');
          switchKnob.style.setProperty('background-color', isChecked ? '#000000' : '#ffffff', 'important');
        } else if (colorState?.highContrastLight) {
          // High contrast light mode
          switchWrapper.style.setProperty('background-color', isChecked ? '#000000' : '#ffffff', 'important');
          switchWrapper.style.setProperty('border', '2px solid #000000', 'important');
          switchKnob.style.setProperty('background-color', isChecked ? '#ffffff' : '#000000', 'important');
        } else {
          // Reset to default CSS styles
          switchWrapper.style.removeProperty('background-color');
          switchWrapper.style.removeProperty('border');
          switchKnob.style.removeProperty('background-color');
        }
      }
    }

    function updateState(newState) {
        // Ensure newState is always a boolean to fix WCAG 4.1.2 setAttribute issue
        const safeNewState = Boolean(newState);
        isChecked = safeNewState;
        switchWrapper.setAttribute('aria-checked', String(safeNewState));
        switchWrapper.classList.toggle('vae-switch-checked', safeNewState);
        applyContrastStyling();
        onChange(safeNewState);
    }

    switchWrapper.addEventListener('click', () => {
        updateState(!isChecked);
    });

    container.appendChild(switchWrapper);
    
    switchWrapper.classList.toggle('vae-switch-checked', safeInitialChecked);
    
    // Apply initial contrast styling
    setTimeout(applyContrastStyling, 0);
    
    // Subscribe to color changes if StateManager is available
    if (typeof VAE !== 'undefined' && VAE.StateManager && VAE.StateManager.subscribe) {
      VAE.StateManager.subscribe('colors', applyContrastStyling);
    }
    
    return { container, setValue: updateState };
  }

  function createProfileCard({
    profileKey,
    title,
    description,
    icon,
    isActive = false,
    onClick = () => {}
  }) {
    const card = document.createElement('div');
    card.className = 'vae-profile-card';
    card.setAttribute('data-profile', profileKey);
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    
    // Ensure isActive is always a boolean to fix WCAG 4.1.2 setAttribute issue
    const safeIsActive = Boolean(isActive);
    card.setAttribute('aria-selected', String(safeIsActive));
    
    if (safeIsActive) {
      card.classList.add('active');
    }
    
    const iconContainer = document.createElement('div');
    iconContainer.className = 'vae-profile-card-icon';
    iconContainer.innerHTML = icon || '';
    card.appendChild(iconContainer);
    
    const titleElement = document.createElement('div');
    titleElement.className = 'vae-profile-card-title';
    titleElement.textContent = title || '';
    card.appendChild(titleElement);
    
    const descriptionElement = document.createElement('div');
    descriptionElement.className = 'vae-profile-card-description';
    descriptionElement.textContent = description || '';
    card.appendChild(descriptionElement);
    
    card.addEventListener('click', (event) => {
      onClick(profileKey, event);
    });
    
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick(profileKey, event);
      }
    });
    
    function setActive(isActiveState) {
      // Ensure isActiveState is always a boolean to fix WCAG 4.1.2 setAttribute issue
      const safeActiveState = Boolean(isActiveState);
      card.classList.toggle('active', safeActiveState);
      card.setAttribute('aria-selected', String(safeActiveState));
    }
    
    setActive(safeIsActive);
    
    return { card, setActive };
  }

  function createOverlay({
    id,
    title,
    contentElements,
    contentHTML,
    onClose = () => {},
    parentElement = document.body,
    disableCloseButton = false,
    coverWidget = false
  }) {
    const overlay = document.createElement('div');
    overlay.id = id;
    overlay.className = 'vae-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', `${id}-title`);
    overlay.setAttribute('hidden', true);

    const header = document.createElement('div');
    header.className = 'vae-overlay-header';

    const titleElement = document.createElement('div');
    titleElement.id = `${id}-title`;
    titleElement.className = 'vae-overlay-title';
    titleElement.textContent = title;

    header.appendChild(titleElement);

    let closeButtonElement;
    if (!disableCloseButton) {
      closeButtonElement = document.createElement('button');
      closeButtonElement.className = 'vae-overlay-close';
      closeButtonElement.setAttribute('aria-label', 'Zurück');
      closeButtonElement.innerHTML = `
        ${arrowLeftSVG}
        <span class="vae-back-text">Zurück</span>
      `;
      header.appendChild(closeButtonElement);
    }

    const contentContainer = document.createElement('div');
    contentContainer.className = 'vae-overlay-content';

    if (contentElements) {
      if (Array.isArray(contentElements)) {
        contentElements.forEach(el => contentContainer.appendChild(el));
      } else if (contentElements instanceof HTMLElement) {
        contentContainer.appendChild(contentElements);
      }
    } else if (contentHTML) {
      contentContainer.innerHTML = contentHTML;
    }

    if (coverWidget) {
      overlay.classList.add('vae-overlay-backdrop');

      const centeringContainer = document.createElement('div');
      centeringContainer.className = 'vae-modal-centering-container';

      const modalDialogBox = document.createElement('div');
      modalDialogBox.className = 'vae-modal-dialog-content-box';

      modalDialogBox.appendChild(header);
      modalDialogBox.appendChild(contentContainer);
      centeringContainer.appendChild(modalDialogBox);
      overlay.appendChild(centeringContainer);
    } else {
      overlay.appendChild(header);
      overlay.appendChild(contentContainer);
    }

    const open = () => {
      overlay.removeAttribute('hidden');
      overlay.classList.add('active');
      
      const focusable = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable.length) {
        focusable[0].focus();
      }
    };

    const close = () => {
      overlay.classList.remove('active');
      overlay.setAttribute('hidden', true);
      onClose();
    };

    if (closeButtonElement) {
      closeButtonElement.addEventListener('click', close);
    }

    parentElement.appendChild(overlay);

    return { overlay, open, close };
  }

  function debounce(fn, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  return {
    createCardComponent,
    createNumericStepper,
    createDropdown,
    createSwitchToggle,
    createProfileCard,
    createOverlay,
    debounce
  };
})();